'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dInvolvement$0024 from "./app.data.-General-Practice-Involvement$.js";
import * as $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dId$0024 from "./app.data.types_general_practice$package$-General-Practice-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$11() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$11 as $c_Lapp_data_AppRegisteredUser$$anon$11 };
$c_Lapp_data_AppRegisteredUser$$anon$11.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$11.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$11;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$11() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$11 as $h_Lapp_data_AppRegisteredUser$$anon$11 };
$h_Lapp_data_AppRegisteredUser$$anon$11.prototype = $c_Lapp_data_AppRegisteredUser$$anon$11.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$11.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$11.prototype.apply__O = (function() {
  var this$1 = $j_app$002edata$002etypes$005fgeneral$005fpractice$0024package$0024$002dGeneral$002dPractice$002dId$0024.$m_Lapp_data_types\uff3fgeneral\uff3fpractice$package$GeneralPracticeId$();
  var evidence$1 = $j_app$002edata$002e$002dGeneral$002dPractice$002dInvolvement$0024.$m_Lapp_data_GeneralPracticeInvolvement$().derived$Schema__Lsttp_tapir_Schema();
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NewtypeULID__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema(this$1, evidence$1);
});
var $d_Lapp_data_AppRegisteredUser$$anon$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$11, "app.data.AppRegisteredUser$$anon$11", ({
  Lapp_data_AppRegisteredUser$$anon$11: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$11 as $d_Lapp_data_AppRegisteredUser$$anon$11 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$11.js.map
